import { Component, DestroyRef, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Component({
  selector: 'refresh',
  templateUrl: './refresh.component.html',
  styleUrls: ['./refresh.component.scss']
})
export class RefreshComponent implements OnInit, OnChanges, OnDestroy {
  private destroyRef = inject(DestroyRef);

  @Input() timespan: number = 60000;
  @Output() elapsed: EventEmitter<any> = new EventEmitter();
  public updateSubscription;

  constructor() { }

  ngOnDestroy(): void {
    this.updateSubscription.unsubscribe();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
     this.updateSubscription = interval(this.timespan).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (val) => {
        //this.callbackFunction();
        this.elapsed.emit();
      }
    );
  }

  ngOnInit() {
  }

}
